/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrintContainerLabelEntry } from '../../models/print-container-label-entry';

export interface PrintContainerLabel$Params {
  containerId: number;
      body: PrintContainerLabelEntry
}

export function printContainerLabel(http: HttpClient, rootUrl: string, params: PrintContainerLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, printContainerLabel.PATH, 'post');
  if (params) {
    rb.path('containerId', params.containerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

printContainerLabel.PATH = '/api/v1/Containers/{containerId}/PrintContainerLabel';
